
import { z } from "zod";
import { validatePhoneNumberWithCommas } from "@/utils/phoneNumberFormatter";
import { normalizeStateName } from "@/utils/countryTimezone";

export const industryOptions = [
  { value: "Apparel and Fashion Manufacturing", label: "Apparel and Fashion Manufacturing" },
  { value: "Chemical Manufacturing", label: "Chemical Manufacturing" },
  { value: "Construction", label: "Construction" },
  { value: "Design Services", label: "Design Services" },
  { value: "Fashion Accessories Manufacturing", label: "Fashion Accessories Manufacturing" },
  { value: "Food and Beverage Services", label: "Food and Beverage Services" },
  { value: "Furniture and Home Furnishings Manufacturing", label: "Furniture and Home Furnishings Manufacturing" },
  { value: "Graphics Design", label: "Graphics Design" },
  { value: "Hospitality", label: "Hospitality" },
  { value: "Interior Design", label: "Interior Design" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Marketing Services", label: "Marketing Services" },
  { value: "Media Production", label: "Media Production" },
  { value: "Motor Vehicle Manufacturing", label: "Motor Vehicle Manufacturing" },
  { value: "Oil and Gas", label: "Oil and Gas" },
  { value: "Photography", label: "Photography" },
  { value: "Post Production", label: "Post Production" },
  { value: "Printing Services", label: "Printing Services" },
  { value: "Retail", label: "Retail" },
  { value: "Retail Apparel and Fashion", label: "Retail Apparel and Fashion" },
  { value: "Retail Luxury Goods and Jewelry", label: "Retail Luxury Goods and Jewelry" },
  { value: "Software Development", label: "Software Development" },
  { value: "Spectator Sports", label: "Spectator Sports" },
  { value: "Sporting Goods Manufacturing", label: "Sporting Goods Manufacturing" },
  { value: "Technology, Information and Internet", label: "Technology, Information and Internet" },
  { value: "Visual Arts", label: "Visual Arts" },
  { value: "Wellness and Fitness Services", label: "Wellness and Fitness Services" },
  { value: "Wholesale", label: "Wholesale" }
];

export const companySizeOptions = [
  { value: "1-10", label: "1-10 employees" },
  { value: "11-50", label: "11-50 employees" },
  { value: "51-200", label: "51-200 employees" },
  { value: "201-500", label: "201-500 employees" },
  { value: "501-1000", label: "501-1000 employees" },
  { value: "1001-5000", label: "1001-5000 employees" },
  { value: "5001-10000", label: "5001-10000 employees" },
  { value: "10000+", label: "10000+ employees" }
];

export const leadStatusOptions = [
  { value: "New", label: "New" },
  { value: "Contacted", label: "Contacted" },
  { value: "Qualified", label: "Qualified" },
  { value: "Proposal", label: "Proposal" },
  { value: "Negotiation", label: "Negotiation" },
  { value: "Won", label: "Won" },
  { value: "Lost", label: "Lost" },
  { value: "Inactive", label: "Inactive" },
  { value: "Active", label: "Active" }
];

export const contactStatusOptions = [
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
  { value: "Do Not Contact", label: "Do Not Contact" }
];

export const jobTitleOptions = [
  { value: "3D Animation Project Manager", label: "3D Animation Project Manager" },
  { value: "3D Animator & Motion Capture Specialist", label: "3D Animator & Motion Capture Specialist" },
  { value: "3D Generalist Designer", label: "3D Generalist Designer" },
  { value: "3D Graphic Artist, Project Manager & Co-Owner", label: "3D Graphic Artist, Project Manager & Co-Owner" },
  { value: "3D Graphics", label: "3D Graphics" },
  { value: "3D Visualisation Creator", label: "3D Visualisation Creator" },
  { value: "Animation Lead & Trainer", label: "Animation Lead & Trainer" },
  { value: "Animator", label: "Animator" },
  { value: "Art Director", label: "Art Director" },
  { value: "Assistant Creative Director", label: "Assistant Creative Director" },
  { value: "Assistant E-commerce Project Manager", label: "Assistant E-commerce Project Manager" },
  { value: "Assistant Editor", label: "Assistant Editor" },
  { value: "Assistant Producer", label: "Assistant Producer" },
  { value: "Associate Producer of Finishing & Post-Production", label: "Associate Producer of Finishing & Post-Production" },
  { value: "B2B Business Development Manager", label: "B2B Business Development Manager" },
  { value: "Brand & Marketing Director", label: "Brand & Marketing Director" },
  { value: "Brand & Product Marketing Coordinator", label: "Brand & Product Marketing Coordinator" },
  { value: "Brand and Communications Manager", label: "Brand and Communications Manager" },
  { value: "Brand Communications Director", label: "Brand Communications Director" },
  { value: "Brand Content & Communications Manager", label: "Brand Content & Communications Manager" },
  { value: "Brand Director", label: "Brand Director" },
  { value: "Brand Manager", label: "Brand Manager" },
  { value: "Camera Operator", label: "Camera Operator" },
  { value: "CEO", label: "CEO" },
  { value: "CEO & Art Director", label: "CEO & Art Director" },
  { value: "CEO & Creative Director", label: "CEO & Creative Director" },
  { value: "CEO & Photographer", label: "CEO & Photographer" },
  { value: "CEO & VFX Supervisor", label: "CEO & VFX Supervisor" },
  { value: "CEO and Designer", label: "CEO and Designer" },
  { value: "CEO, Founder & Owner", label: "CEO, Founder & Owner" },
  { value: "CEO, Art Director & Motion Designer", label: "CEO, Art Director & Motion Designer" },
  { value: "CG Generalist", label: "CG Generalist" },
  { value: "Chief Creative Officer", label: "Chief Creative Officer" },
  { value: "Chief Design Officer", label: "Chief Design Officer" },
  { value: "Chief Digital Officer", label: "Chief Digital Officer" },
  { value: "Chief E-commerce Business Officer", label: "Chief E-commerce Business Officer" },
  { value: "Chief Marketing Officer", label: "Chief Marketing Officer" },
  { value: "Cinematographer", label: "Cinematographer" },
  { value: "Co-Founder", label: "Co-Founder" },
  { value: "Co-Founder & CEO", label: "Co-Founder & CEO" },
  { value: "Co-Founder & Chief Design Officer", label: "Co-Founder & Chief Design Officer" },
  { value: "Co-Founder, Communications & Administration", label: "Co-Founder, Communications & Administration" },
  { value: "Co-Founder & COO", label: "Co-Founder & COO" },
  { value: "Co-Founder & Creative Director", label: "Co-Founder & Creative Director" },
  { value: "Co-Founder & General Manager", label: "Co-Founder & General Manager" },
  { value: "Co-Founder & President", label: "Co-Founder & President" },
  { value: "Commercial Photographer", label: "Commercial Photographer" },
  { value: "Content Creator & Photographer", label: "Content Creator & Photographer" },
  { value: "Content Marketing Specialist", label: "Content Marketing Specialist" },
  { value: "Co-Owner", label: "Co-Owner" },
  { value: "Creative", label: "Creative" },
  { value: "Creative & Concept Manager", label: "Creative & Concept Manager" },
  { value: "Creative Director", label: "Creative Director" },
  { value: "Creative Director & Company Owner", label: "Creative Director & Company Owner" },
  { value: "Creative Director & Founder", label: "Creative Director & Founder" },
  { value: "Creative Director & Partner", label: "Creative Director & Partner" },
  { value: "Creative Director & Scientific Storyboarder", label: "Creative Director & Scientific Storyboarder" },
  { value: "Creative Director Assistant", label: "Creative Director Assistant" },
  { value: "Creative Director, VFX Supervisor & Post-Production", label: "Creative Director, VFX Supervisor & Post-Production" },
  { value: "Creative Executive", label: "Creative Executive" },
  { value: "Creative Retoucher, Post-Production", label: "Creative Retoucher, Post-Production" },
  { value: "Creative Services Director", label: "Creative Services Director" },
  { value: "Creative Video Editor", label: "Creative Video Editor" },
  { value: "Deputy CEO", label: "Deputy CEO" },
  { value: "Digital Photographer", label: "Digital Photographer" },
  { value: "Director", label: "Director" },
  { value: "Director & Co-Founder", label: "Director & Co-Founder" },
  { value: "Director of Photography & Creative Director", label: "Director of Photography & Creative Director" },
  { value: "Director & Founder", label: "Director & Founder" },
  { value: "Director & Producer", label: "Director & Producer" },
  { value: "Director of Creative Projects & Publishing", label: "Director of Creative Projects & Publishing" },
  { value: "Director of Digital Techniques", label: "Director of Digital Techniques" },
  { value: "Director of E-commerce", label: "Director of E-commerce" },
  { value: "Director of Photography", label: "Director of Photography" },
  { value: "Director of Productions & Producer", label: "Director of Productions & Producer" },
  { value: "Director of Sales and Business Development", label: "Director of Sales and Business Development" },
  { value: "Director of Video Production", label: "Director of Video Production" },
  { value: "E-commerce & Wholesale Photo Producer", label: "E-commerce & Wholesale Photo Producer" },
  { value: "E-commerce Operations Manager", label: "E-commerce Operations Manager" },
  { value: "E-commerce", label: "E-commerce" },
  { value: "E-commerce & Content Coordinator", label: "E-commerce & Content Coordinator" },
  { value: "E-commerce & Digital Director", label: "E-commerce & Digital Director" },
  { value: "E-commerce & Digital Marketing Coordinator", label: "E-commerce & Digital Marketing Coordinator" },
  { value: "E-commerce & Marketing Controller & Analyst", label: "E-commerce & Marketing Controller & Analyst" },
  { value: "E-commerce & Retail Manager", label: "E-commerce & Retail Manager" },
  { value: "E-commerce and Social Media Headshot Photographer", label: "E-commerce and Social Media Headshot Photographer" },
  { value: "E-commerce Assistant", label: "E-commerce Assistant" },
  { value: "E-commerce Coordinator", label: "E-commerce Coordinator" },
  { value: "E-commerce Director", label: "E-commerce Director" },
  { value: "E-commerce Manager", label: "E-commerce Manager" },
  { value: "E-commerce Photographer", label: "E-commerce Photographer" },
  { value: "E-commerce Project Manager & Retail Coordinator", label: "E-commerce Project Manager & Retail Coordinator" },
  { value: "E-commerce Specialist", label: "E-commerce Specialist" },
  { value: "Editor", label: "Editor" },
  { value: "Executive Director", label: "Executive Director" },
  { value: "Executive Producer & Managing Director", label: "Executive Producer & Managing Director" },
  { value: "Fashion Designer & Creative Director", label: "Fashion Designer & Creative Director" },
  { value: "Fashion Photographer", label: "Fashion Photographer" },
  { value: "Film Director", label: "Film Director" },
  { value: "Filmmaker", label: "Filmmaker" },
  { value: "Founder", label: "Founder" },
  { value: "Founder & 3D Generalist", label: "Founder & 3D Generalist" },
  { value: "Founder & Artistic Director", label: "Founder & Artistic Director" },
  { value: "Founder & CEO", label: "Founder & CEO" },
  { value: "Founder & CG Artist", label: "Founder & CG Artist" },
  { value: "Founder & Creative Director", label: "Founder & Creative Director" },
  { value: "Founder & Head of Production", label: "Founder & Head of Production" },
  { value: "Founder & Motion Designer", label: "Founder & Motion Designer" },
  { value: "Founder & Photographer", label: "Founder & Photographer" },
  { value: "Founder and Manager", label: "Founder and Manager" },
  { value: "Founder and Managing Partner", label: "Founder and Managing Partner" },
  { value: "Founder and President", label: "Founder and President" },
  { value: "Founder & Sales Representative", label: "Founder & Sales Representative" },
  { value: "Founder, Senior 3D Artist", label: "Founder, Senior 3D Artist" },
  { value: "Fractional E-commerce Director", label: "Fractional E-commerce Director" },
  { value: "Freelance Post-Production Coordinator", label: "Freelance Post-Production Coordinator" },
  { value: "Freelance Producer", label: "Freelance Producer" },
  { value: "General Manager", label: "General Manager" },
  { value: "Global Brand & Product Marketing Manager", label: "Global Brand & Product Marketing Manager" },
  { value: "Global Brand Creative Director", label: "Global Brand Creative Director" },
  { value: "Global Brand Image & Content Director", label: "Global Brand Image & Content Director" },
  { value: "Global Commercial Manager", label: "Global Commercial Manager" },
  { value: "Global Creative Director", label: "Global Creative Director" },
  { value: "Global Creative Lead", label: "Global Creative Lead" },
  { value: "Global E-commerce Catalog Manager", label: "Global E-commerce Catalog Manager" },
  { value: "Global E-commerce Director", label: "Global E-commerce Director" },
  { value: "Global E-commerce Manager", label: "Global E-commerce Manager" },
  { value: "Global Head of E-commerce", label: "Global Head of E-commerce" },
  { value: "Global Head of E-commerce Excellence", label: "Global Head of E-commerce Excellence" },
  { value: "Global Head of E-commerce Production", label: "Global Head of E-commerce Production" },
  { value: "Global Head of Marketing & Communications", label: "Global Head of Marketing & Communications" },
  { value: "Graphic 3D & Motion Designer", label: "Graphic 3D & Motion Designer" },
  { value: "Graphic Design & E-commerce", label: "Graphic Design & E-commerce" },
  { value: "Graphic Design & Marketing", label: "Graphic Design & Marketing" },
  { value: "Graphic Designer", label: "Graphic Designer" },
  { value: "Growth Marketer", label: "Growth Marketer" },
  { value: "Head Graphic Designer", label: "Head Graphic Designer" },
  { value: "Head of Brand", label: "Head of Brand" },
  { value: "Head of Brand Marketing", label: "Head of Brand Marketing" },
  { value: "Head of Brand Marketing & Communications", label: "Head of Brand Marketing & Communications" },
  { value: "Head of Content & Creative", label: "Head of Content & Creative" },
  { value: "Head of Creative", label: "Head of Creative" },
  { value: "Head of Creative Operations", label: "Head of Creative Operations" },
  { value: "Head of E-commerce", label: "Head of E-commerce" },
  { value: "Head of E-commerce & Marketing", label: "Head of E-commerce & Marketing" },
  { value: "Head of Marketing", label: "Head of Marketing" },
  { value: "Head of Marketing & E-commerce", label: "Head of Marketing & E-commerce" },
  { value: "Head of Photo Studio", label: "Head of Photo Studio" },
  { value: "Head of Post-Production", label: "Head of Post-Production" },
  { value: "Head of Production", label: "Head of Production" },
  { value: "Head of Production & Logistics Manager", label: "Head of Production & Logistics Manager" },
  { value: "Head of Productions", label: "Head of Productions" },
  { value: "Head of Sales", label: "Head of Sales" },
  { value: "Head of Sales and Marketing", label: "Head of Sales and Marketing" },
  { value: "Head of Video Production", label: "Head of Video Production" },
  { value: "Head of Visuals", label: "Head of Visuals" },
  { value: "Head Photographer", label: "Head Photographer" },
  { value: "Headshot Photographer", label: "Headshot Photographer" },
  { value: "High-End Digital Retoucher and Image Creator", label: "High-End Digital Retoucher and Image Creator" },
  { value: "Illustrator & Motion Designer", label: "Illustrator & Motion Designer" },
  { value: "Image Director", label: "Image Director" },
  { value: "In-House Photographer", label: "In-House Photographer" },
  { value: "Junior E-commerce Coordinator", label: "Junior E-commerce Coordinator" },
  { value: "Junior Marketing Coordinator", label: "Junior Marketing Coordinator" },
  { value: "Junior Photographer & Photo Assistant", label: "Junior Photographer & Photo Assistant" },
  { value: "Lead Animator", label: "Lead Animator" },
  { value: "Lead Producer", label: "Lead Producer" },
  { value: "Line Producer", label: "Line Producer" },
  { value: "Manager, Owner & Photographer", label: "Manager, Owner & Photographer" },
  { value: "Managing Director", label: "Managing Director" },
  { value: "Managing Director & Co-Founder", label: "Managing Director & Co-Founder" },
  { value: "Managing Director & Executive Producer", label: "Managing Director & Executive Producer" },
  { value: "Marketing & Communications", label: "Marketing & Communications" },
  { value: "Marketing & Communications Project Manager", label: "Marketing & Communications Project Manager" },
  { value: "Marketing & E-commerce Coordinator", label: "Marketing & E-commerce Coordinator" },
  { value: "Marketing and Communications Manager", label: "Marketing and Communications Manager" },
  { value: "Marketing & Public Relations Specialist", label: "Marketing & Public Relations Specialist" },
  { value: "Marketing Assistant", label: "Marketing Assistant" },
  { value: "Marketing Automation Specialist", label: "Marketing Automation Specialist" },
  { value: "Marketing Coordinator", label: "Marketing Coordinator" },
  { value: "Marketing Director", label: "Marketing Director" },
  { value: "Marketing Manager", label: "Marketing Manager" },
  { value: "Owner", label: "Owner" },
  { value: "Owner, Art Director & CG Artist", label: "Owner, Art Director & CG Artist" },
  { value: "Owner & Executive Producer", label: "Owner & Executive Producer" },
  { value: "Owner & Photographer", label: "Owner & Photographer" },
  { value: "Owner and Production Director", label: "Owner and Production Director" },
  { value: "Partner", label: "Partner" },
  { value: "Photo Retoucher", label: "Photo Retoucher" },
  { value: "Photographer", label: "Photographer" },
  { value: "Photographer & Content Creator", label: "Photographer & Content Creator" },
  { value: "Photographer & Creative Director", label: "Photographer & Creative Director" },
  { value: "Photographer & Director", label: "Photographer & Director" },
  { value: "Photographer & Image Coordinator", label: "Photographer & Image Coordinator" },
  { value: "Photographer, Retoucher & Video Editor", label: "Photographer, Retoucher & Video Editor" },
  { value: "Photographer, Art Director & Owner", label: "Photographer, Art Director & Owner" },
  { value: "Photographer, Retoucher & 3D Artist", label: "Photographer, Retoucher & 3D Artist" },
  { value: "Post Producer", label: "Post Producer" },
  { value: "Post-Production Coordinator", label: "Post-Production Coordinator" },
  { value: "Post-Production Manager", label: "Post-Production Manager" },
  { value: "Post-Production Supervisor", label: "Post-Production Supervisor" },
  { value: "President", label: "President" },
  { value: "Producer", label: "Producer" },
  { value: "Product Photographer", label: "Product Photographer" },
  { value: "Production Assistant", label: "Production Assistant" },
  { value: "Production Coordinator", label: "Production Coordinator" },
  { value: "Production Director", label: "Production Director" },
  { value: "Production Manager", label: "Production Manager" },
  { value: "Professional Photographer", label: "Professional Photographer" },
  { value: "Project and Post-Production Manager", label: "Project and Post-Production Manager" },
  { value: "Project Manager & Senior 3D Artist", label: "Project Manager & Senior 3D Artist" },
  { value: "Retoucher", label: "Retoucher" },
  { value: "Senior 3D Artist", label: "Senior 3D Artist" },
  { value: "Senior Creative Designer", label: "Senior Creative Designer" },
  { value: "Senior Creative Director", label: "Senior Creative Director" },
  { value: "Senior Director of Production and Operations", label: "Senior Director of Production and Operations" },
  { value: "Senior Motion Designer", label: "Senior Motion Designer" },
  { value: "Senior Photographer", label: "Senior Photographer" },
  { value: "Senior Producer", label: "Senior Producer" },
  { value: "Studio Director", label: "Studio Director" },
  { value: "Studio Director, Producer & 3D Generalist", label: "Studio Director, Producer & 3D Generalist" },
  { value: "Studio Manager", label: "Studio Manager" },
  { value: "Studio Photographer", label: "Studio Photographer" },
  { value: "Supervisor, 3D Generalist", label: "Supervisor, 3D Generalist" },
  { value: "Team Lead", label: "Team Lead" },
  { value: "VFX Project Manager", label: "VFX Project Manager" },
  { value: "VFX Supervisor", label: "VFX Supervisor" },
  { value: "Vice President & Co-Founder", label: "Vice President & Co-Founder" },
  { value: "Video & Marketing Specialist", label: "Video & Marketing Specialist" },
  { value: "Video Producer", label: "Video Producer" },
  { value: "Videographer", label: "Videographer" },
  { value: "Visual Effects Artist", label: "Visual Effects Artist" },
  { value: "Visualiser", label: "Visualiser" }
];

export const departmentOptions = [
  { value: "E-commerce", label: "E-commerce" },
  { value: "Post-Production", label: "Post-Production" },
  { value: "Photography", label: "Photography" },
  { value: "3D/Image", label: "3D/Image" },
  { value: "Creative", label: "Creative" },
  { value: "Design", label: "Design" },
  { value: "Video Production", label: "Video Production" },
  { value: "Content", label: "Content" },
  { value: "Marketing", label: "Marketing" },
  { value: "Sales", label: "Sales" },
  { value: "Business Development", label: "Business Development" },
  { value: "Customer Service", label: "Customer Service" },
  { value: "Operations", label: "Operations" },
  { value: "Finance", label: "Finance" },
  { value: "Human Resources", label: "Human Resources" },
  { value: "Legal", label: "Legal" },
  { value: "Administration", label: "Administration" },
  { value: "Engineering", label: "Engineering" },
  { value: "IT", label: "IT" },
  { value: "Product", label: "Product" },
  { value: "Quality Assurance", label: "Quality Assurance" },
  { value: "Research & Development", label: "Research & Development" },
  { value: "Management", label: "Management" },
  { value: "Executive", label: "Executive" },
  { value: "Other", label: "Other" },
  { value: "Not Sure", label: "Not Sure" }
];

export const countryOptions = [
  { value: "Afghanistan", label: "Afghanistan" },
  { value: "Albania", label: "Albania" },
  { value: "Algeria", label: "Algeria" },
  { value: "Argentina", label: "Argentina" },
  { value: "Australia", label: "Australia" },
  { value: "Austria", label: "Austria" },
  { value: "Bangladesh", label: "Bangladesh" },
  { value: "Belgium", label: "Belgium" },
  { value: "Brazil", label: "Brazil" },
  { value: "Canada", label: "Canada" },
  { value: "Chile", label: "Chile" },
  { value: "China", label: "China" },
  { value: "Colombia", label: "Colombia" },
  { value: "Denmark", label: "Denmark" },
  { value: "Egypt", label: "Egypt" },
  { value: "Finland", label: "Finland" },
  { value: "France", label: "France" },
  { value: "Germany", label: "Germany" },
  { value: "Ghana", label: "Ghana" },
  { value: "Greece", label: "Greece" },
  { value: "India", label: "India" },
  { value: "Indonesia", label: "Indonesia" },
  { value: "Iran", label: "Iran" },
  { value: "Iraq", label: "Iraq" },
  { value: "Ireland", label: "Ireland" },
  { value: "Israel", label: "Israel" },
  { value: "Italy", label: "Italy" },
  { value: "Japan", label: "Japan" },
  { value: "Jordan", label: "Jordan" },
  { value: "Kenya", label: "Kenya" },
  { value: "Latvia", label: "Latvia" },
  { value: "North Korea", label: "North Korea" },
  { value: "Malaysia", label: "Malaysia" },
  { value: "Mexico", label: "Mexico" },
  { value: "Morocco", label: "Morocco" },
  { value: "Netherlands", label: "Netherlands" },
  { value: "New Zealand", label: "New Zealand" },
  { value: "Nigeria", label: "Nigeria" },
  { value: "Norway", label: "Norway" },
  { value: "Pakistan", label: "Pakistan" },
  { value: "Philippines", label: "Philippines" },
  { value: "Poland", label: "Poland" },
  { value: "Portugal", label: "Portugal" },
  { value: "Russia", label: "Russia" },
  { value: "Saudi Arabia", label: "Saudi Arabia" },
  { value: "Singapore", label: "Singapore" },
  { value: "South Africa", label: "South Africa" },
  { value: "South Korea", label: "South Korea" },
  { value: "Spain", label: "Spain" },
  { value: "Sweden", label: "Sweden" },
  { value: "Switzerland", label: "Switzerland" },
  { value: "Thailand", label: "Thailand" },
  { value: "Turkey", label: "Turkey" },
  { value: "Ukraine", label: "Ukraine" },
  { value: "United Arab Emirates", label: "United Arab Emirates" },
  { value: "United Kingdom", label: "United Kingdom" },
  { value: "United States", label: "United States" },
  { value: "Vietnam", label: "Vietnam" }
];

// Schema for lead form
export const leadFormSchema = z.object({
  name: z.string().min(1, { message: "Company name is required" }),
  industry: z.string().optional(),
  company_size: z.string().optional(),
  website_url: z.string().optional(),
  phone: z.string().optional().refine((value) => {
    if (!value) return true; // Allow empty values
    const { isValid } = validatePhoneNumberWithCommas(value);
    return isValid;
  }, { message: "Phone numbers must start with + and be comma-separated for multiple numbers" }),
  linkedin_url: z.string().optional(),
  twitter_url: z.string().optional(),
  facebook_url: z.string().optional(),
  company_info: z.string().optional(),
  address: z.string().optional(),
  country: z.string().optional(),
  state: z.string().optional().transform((value) => {
    if (!value || value.trim() === '') return value;
    const normalized = normalizeStateName(value);
    return normalized || value; // Return normalized or original if normalization fails
  }),
  city: z.string().optional(),
  zip_code: z.string().optional(),
  lead_score: z.number().nullable().optional(),
  sentiment_score: z.number().nullable().optional(),
  engagement_score: z.number().nullable().optional(),
  status: z.string().default("New"),
  target_market: z.string().optional(),
  pain_points: z.string().optional(),
  ai_summary: z.string().optional(),
  logo_url: z.string().optional(),
  assigned_to: z.number().nullable().optional(),
  created_by: z.number().nullable().optional(),
});

export type LeadFormValues = z.infer<typeof leadFormSchema>;

// Schema for contact form
export const contactFormSchema = z.object({
  first_name: z.string().min(1, { message: "First name is required" }),
  last_name: z.string().min(1, { message: "Last name is required" }),
  company_id: z.string().optional(),
  designation: z.string().optional(),
  department: z.string().optional(),
  email: z.array(z.object({
    email: z.string().min(1),
    type: z.enum(["official", "personal", "cell", "store", "others"]),
    is_primary: z.boolean()
  })).optional(),
  phone: z.array(z.object({
    phone: z.string().min(1),
    type: z.enum(["official", "personal", "cell", "store", "others"]),
    is_primary: z.boolean()
  })).optional(),
  decision_maker: z.boolean().optional().default(false),
  
  // URLs object for multiple social/professional links (supports dynamic fields) - no validation
  urls: z.any().optional(),
  
  notes: z.string().optional(),
  status: z.enum(contactStatusOptions.map(option => option.value) as [string, ...string[]]).optional(),
  
  // Enhanced metadata for rich contact information (supports dynamic fields) - no validation
  metadata: z.any().optional(),
  
  // Legacy fields for backward compatibility
  company_name: z.string().optional(),
  website_url: z.string().optional(),
  industry: z.string().optional(),
  company_size: z.string().optional(),
  twitter_url: z.string().optional(),
  company_info: z.string().optional(),
  address: z.string().optional(),
  country: z.string().optional(),
  state: z.string().optional(),
  city: z.string().optional(),
  zip_code: z.string().optional(),
  engagement_score: z.number().nullable().optional(),
  lead_score: z.number().nullable().optional(),
  sentiment_score: z.number().nullable().optional(),
  target_market: z.string().optional(),
  pain_points: z.string().optional(),
  ai_summary: z.string().nullable().optional(),
  logo_url: z.string().nullable().optional(),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
